export const environment = {
  production: true,
  buildId: '4199531376325021',
  configFile: 'config.json',
};
